export const MONSTERS_REGIST = [
    {
        No: "000(00)",
        名前: "スライム",
        attack: "0",
        sleep: "0",
        curse: "7",
        ascension: "0",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "001(01)",
        名前: "おおナメクジ",
        attack: "0",
        sleep: "0",
        curse: "7",
        ascension: "0",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "002(02)",
        名前: "アイアンアント",
        attack: "0",
        sleep: "0",
        curse: "7",
        ascension: "0",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "003(03)",
        名前: "ドラキー",
        attack: "0",
        sleep: "0",
        curse: "7",
        ascension: "0",
        dazzle: "1",
        morimaru: "0"
    },
    {
        No: "004(04)",
        名前: "やまねずみ",
        attack: "0",
        sleep: "0",
        curse: "7",
        ascension: "0",
        dazzle: "2",
        morimaru: "0"
    },
    {
        No: "005(05)",
        名前: "ホイミスライム",
        attack: "1",
        sleep: "2",
        curse: "7",
        ascension: "1",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "006(06)",
        名前: "ゆうれい",
        attack: "0",
        sleep: "0",
        curse: "7",
        ascension: "0",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "007(07)",
        名前: "バブルスライム",
        attack: "0",
        sleep: "1",
        curse: "7",
        ascension: "0",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "008(08)",
        名前: "ぐんたいアリ",
        attack: "0",
        sleep: "2",
        curse: "7",
        ascension: "1",
        dazzle: "1",
        morimaru: "0"
    },
    {
        No: "009(09)",
        名前: "まじゅつし",
        attack: "0",
        sleep: "0",
        curse: "0",
        ascension: "1",
        dazzle: "1",
        morimaru: "0"
    },
    {
        No: "010(0A)",
        名前: "おおねずみ",
        attack: "0",
        sleep: "0",
        curse: "7",
        ascension: "1",
        dazzle: "2",
        morimaru: "0"
    },
    {
        No: "011(0B)",
        名前: "キングコブラ",
        attack: "0",
        sleep: "1",
        curse: "7",
        ascension: "1",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "012(0C)",
        名前: "ラリホーアント",
        attack: "0",
        sleep: "1",
        curse: "0",
        ascension: "0",
        dazzle: "2",
        morimaru: "0"
    },
    {
        No: "013(0D)",
        名前: "タホドラキー",
        attack: "0",
        sleep: "2",
        curse: "3",
        ascension: "0",
        dazzle: "2",
        morimaru: "0"
    },
    {
        No: "014(0E)",
        名前: "よろいムカデ",
        attack: "0",
        sleep: "1",
        curse: "7",
        ascension: "1",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "015(0F)",
        名前: "しびれくらげ",
        attack: "0",
        sleep: "1",
        curse: "7",
        ascension: "0",
        dazzle: "1",
        morimaru: "0"
    },
    {
        No: "016(10)",
        名前: "リザードフライ",
        attack: "0",
        sleep: "2",
        curse: "3",
        ascension: "1",
        dazzle: "1",
        morimaru: "0"
    },
    {
        No: "017(11)",
        名前: "リビングデッド",
        attack: "0",
        sleep: "7",
        curse: "7",
        ascension: "7",
        dazzle: "1",
        morimaru: "0"
    },
    {
        No: "018(12)",
        名前: "スモーク",
        attack: "4",
        sleep: "1",
        curse: "2",
        ascension: "0",
        dazzle: "0",
        morimaru: "2"
    },
    {
        No: "019(13)",
        名前: "おばけねずみ",
        attack: "0",
        sleep: "1",
        curse: "7",
        ascension: "0",
        dazzle: "3",
        morimaru: "0"
    },
    {
        No: "020(14)",
        名前: "マンドリル",
        attack: "0",
        sleep: "2",
        curse: "7",
        ascension: "0",
        dazzle: "1",
        morimaru: "0"
    },
    {
        No: "021(15)",
        名前: "マンイーター",
        attack: "0",
        sleep: "2",
        curse: "7",
        ascension: "0",
        dazzle: "7",
        morimaru: "0"
    },
    {
        No: "022(16)",
        名前: "かぶとムカデ",
        attack: "0",
        sleep: "1",
        curse: "7",
        ascension: "0",
        dazzle: "2",
        morimaru: "0"
    },
    {
        No: "023(17)",
        名前: "うみうし",
        attack: "2",
        sleep: "1",
        curse: "7",
        ascension: "3",
        dazzle: "1",
        morimaru: "0"
    },
    {
        No: "024(18)",
        名前: "メドーサボール",
        attack: "0",
        sleep: "5",
        curse: "0",
        ascension: "1",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "025(19)",
        名前: "きとうし",
        attack: "1",
        sleep: "4",
        curse: "0",
        ascension: "1",
        dazzle: "0",
        morimaru: "1"
    },
    {
        No: "026(1A)",
        名前: "どろにんぎょう",
        attack: "4",
        sleep: "0",
        curse: "7",
        ascension: "2",
        dazzle: "3",
        morimaru: "2"
    },
    {
        No: "027(1B)",
        名前: "バブーン",
        attack: "0",
        sleep: "2",
        curse: "7",
        ascension: "1",
        dazzle: "0",
        morimaru: "1"
    },
    {
        No: "028(1C)",
        名前: "しにがみ",
        attack: "0",
        sleep: "3",
        curse: "7",
        ascension: "3",
        dazzle: "0",
        morimaru: "1"
    },
    {
        No: "029(1D)",
        名前: "グレムリン",
        attack: "1",
        sleep: "3",
        curse: "2",
        ascension: "2",
        dazzle: "0",
        morimaru: "2"
    },
    {
        No: "030(1E)",
        名前: "ポイズンキッス",
        attack: "1",
        sleep: "2",
        curse: "7",
        ascension: "1",
        dazzle: "1",
        morimaru: "1"
    },
    {
        No: "031(1F)",
        名前: "ミイラおとこ",
        attack: "0",
        sleep: "7",
        curse: "7",
        ascension: "5",
        dazzle: "2",
        morimaru: "2"
    },
    {
        No: "032(20)",
        名前: "ゴーゴンヘッド",
        attack: "0",
        sleep: "3",
        curse: "4",
        ascension: "1",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "033(21)",
        名前: "サーベルウルフ",
        attack: "0",
        sleep: "1",
        curse: "7",
        ascension: "2",
        dazzle: "2",
        morimaru: "0"
    },
    {
        No: "034(22)",
        名前: "ドラゴンフライ",
        attack: "0",
        sleep: "7",
        curse: "7",
        ascension: "3",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "035(23)",
        名前: "じんめんじゅ",
        attack: "0",
        sleep: "1",
        curse: "7",
        ascension: "4",
        dazzle: "3",
        morimaru: "3"
    },
    {
        No: "036(24)",
        名前: "アンデッドマン",
        attack: "0",
        sleep: "2",
        curse: "7",
        ascension: "7",
        dazzle: "1",
        morimaru: "2"
    },
    {
        No: "037(25)",
        名前: "バシリスク",
        attack: "0",
        sleep: "0",
        curse: "7",
        ascension: "1",
        dazzle: "0",
        morimaru: "2"
    },
    {
        No: "038(26)",
        名前: "マドハンド",
        attack: "0",
        sleep: "1",
        curse: "7",
        ascension: "2",
        dazzle: "7",
        morimaru: "0"
    },
    {
        No: "039(27)",
        名前: "オーク",
        attack: "1",
        sleep: "2",
        curse: "7",
        ascension: "4",
        dazzle: "1",
        morimaru: "2"
    },
    {
        No: "040(28)",
        名前: "パペットマン",
        attack: "3",
        sleep: "6",
        curse: "7",
        ascension: "2",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "041(29)",
        名前: "マミー",
        attack: "0",
        sleep: "7",
        curse: "7",
        ascension: "1",
        dazzle: "1",
        morimaru: "3"
    },
    {
        No: "042(2A)",
        名前: "ウドラー",
        attack: "0",
        sleep: "3",
        curse: "1",
        ascension: "1",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "043(2B)",
        名前: "ガスト",
        attack: "1",
        sleep: "7",
        curse: "1",
        ascension: "1",
        dazzle: "3",
        morimaru: "1"
    },
    {
        No: "044(2C)",
        名前: "くさったしたい",
        attack: "0",
        sleep: "2",
        curse: "7",
        ascension: "7",
        dazzle: "2",
        morimaru: "7"
    },
    {
        No: "045(2D)",
        名前: "ホークマン",
        attack: "0",
        sleep: "2",
        curse: "1",
        ascension: "2",
        dazzle: "1",
        morimaru: "0"
    },
    {
        No: "046(2E)",
        名前: "ようじゅつし",
        attack: "1",
        sleep: "2",
        curse: "2",
        ascension: "2",
        dazzle: "2",
        morimaru: "2"
    },
    {
        No: "047(2F)",
        名前: "メタルスライム",
        attack: "7",
        sleep: "7",
        curse: "7",
        ascension: "7",
        dazzle: "7",
        morimaru: "7"
    },
    {
        No: "048(30)",
        名前: "くびかりぞく",
        attack: "0",
        sleep: "0",
        curse: "7",
        ascension: "1",
        dazzle: "1",
        morimaru: "0"
    },
    {
        No: "049(31)",
        名前: "あくまのめだま",
        attack: "1",
        sleep: "2",
        curse: "7",
        ascension: "3",
        dazzle: "0",
        morimaru: "2"
    },
    {
        No: "050(32)",
        名前: "ヒババンゴ",
        attack: "0",
        sleep: "1",
        curse: "1",
        ascension: "3",
        dazzle: "1",
        morimaru: "0"
    },
    {
        No: "051(33)",
        名前: "ブラッドハンド",
        attack: "1",
        sleep: "2",
        curse: "7",
        ascension: "2",
        dazzle: "7",
        morimaru: "7"
    },
    {
        No: "052(34)",
        名前: "ゴールドオーク",
        attack: "2",
        sleep: "2",
        curse: "2",
        ascension: "5",
        dazzle: "4",
        morimaru: "1"
    },
    {
        No: "053(35)",
        名前: "じごくのつかい",
        attack: "0",
        sleep: "2",
        curse: "2",
        ascension: "3",
        dazzle: "3",
        morimaru: "1"
    },
    {
        No: "054(36)",
        名前: "グール",
        attack: "0",
        sleep: "1",
        curse: "0",
        ascension: "3",
        dazzle: "0",
        morimaru: "1"
    },
    {
        No: "055(37)",
        名前: "バピラス",
        attack: "0",
        sleep: "2",
        curse: "7",
        ascension: "1",
        dazzle: "0",
        morimaru: "1"
    },
    {
        No: "056(38)",
        名前: "スカルナイト",
        attack: "0",
        sleep: "1",
        curse: "3",
        ascension: "4",
        dazzle: "1",
        morimaru: "1"
    },
    {
        No: "057(39)",
        名前: "キラータイガー",
        attack: "2",
        sleep: "7",
        curse: "7",
        ascension: "1",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "058(3A)",
        名前: "メタルハンター",
        attack: "4",
        sleep: "3",
        curse: "7",
        ascension: "5",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "059(3B)",
        名前: "ベビル",
        attack: "1",
        sleep: "0",
        curse: "3",
        ascension: "4",
        dazzle: "3",
        morimaru: "0"
    },
    {
        No: "060(3C)",
        名前: "ダークアイ",
        attack: "4",
        sleep: "7",
        curse: "7",
        ascension: "1",
        dazzle: "5",
        morimaru: "4"
    },
    {
        No: "061(3D)",
        名前: "ガーゴイル",
        attack: "0",
        sleep: "1",
        curse: "2",
        ascension: "0",
        dazzle: "1",
        morimaru: "2"
    },
    {
        No: "062(3E)",
        名前: "オークキング",
        attack: "0",
        sleep: "1",
        curse: "1",
        ascension: "4",
        dazzle: "0",
        morimaru: "2"
    },
    {
        No: "063(3F)",
        名前: "メイジバピラス",
        attack: "4",
        sleep: "1",
        curse: "2",
        ascension: "0",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "064(40)",
        名前: "バーサーカー",
        attack: "0",
        sleep: "0",
        curse: "7",
        ascension: "1",
        dazzle: "1",
        morimaru: "0"
    },
    {
        No: "065(41)",
        名前: "はぐれメタル",
        attack: "7",
        sleep: "7",
        curse: "7",
        ascension: "7",
        dazzle: "7",
        morimaru: "7"
    },
    {
        No: "066(42)",
        名前: "ハーゴンのきし",
        attack: "0",
        sleep: "7",
        curse: "2",
        ascension: "2",
        dazzle: "1",
        morimaru: "0"
    },
    {
        No: "067(43)",
        名前: "サイクロプス",
        attack: "0",
        sleep: "3",
        curse: "7",
        ascension: "2",
        dazzle: "0",
        morimaru: "3"
    },
    {
        No: "068(44)",
        名前: "キラーマシン",
        attack: "7",
        sleep: "7",
        curse: "7",
        ascension: "7",
        dazzle: "1",
        morimaru: "0"
    },
    {
        No: "069(45)",
        名前: "ドラゴン",
        attack: "0",
        sleep: "2",
        curse: "7",
        ascension: "1",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "070(46)",
        名前: "あくましんかん",
        attack: "3",
        sleep: "7",
        curse: "2",
        ascension: "4",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "071(47)",
        名前: "フレイム",
        attack: "7",
        sleep: "1",
        curse: "7",
        ascension: "2",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "072(48)",
        名前: "シルバーデビル",
        attack: "0",
        sleep: "1",
        curse: "7",
        ascension: "2",
        dazzle: "4",
        morimaru: "0"
    },
    {
        No: "073(49)",
        名前: "ブリザード",
        attack: "0",
        sleep: "6",
        curse: "4",
        ascension: "3",
        dazzle: "2",
        morimaru: "0"
    },
    {
        No: "074(4A)",
        名前: "ギガンテス",
        attack: "1",
        sleep: "7",
        curse: "7",
        ascension: "6",
        dazzle: "2",
        morimaru: "0"
    },
    {
        No: "075(4B)",
        名前: "デビルロード",
        attack: "3",
        sleep: "2",
        curse: "1",
        ascension: "6",
        dazzle: "2",
        morimaru: "0"
    },
    {
        No: "076(4C)",
        名前: "アークデーモン",
        attack: "2",
        sleep: "2",
        curse: "2",
        ascension: "6",
        dazzle: "2",
        morimaru: "0"
    },
    {
        No: "077(4D)",
        名前: "アトラス",
        attack: "7",
        sleep: "7",
        curse: "7",
        ascension: "7",
        dazzle: "3",
        morimaru: "0"
    },
    {
        No: "078(4E)",
        名前: "バズズ",
        attack: "5",
        sleep: "2",
        curse: "7",
        ascension: "5",
        dazzle: "0",
        morimaru: "0"
    },
    {
        No: "079(4F)",
        名前: "ベリアル",
        attack: "3",
        sleep: "7",
        curse: "7",
        ascension: "7",
        dazzle: "5",
        morimaru: "7"
    },
    {
        No: "080(50)",
        名前: "ハーゴン",
        attack: "2",
        sleep: "7",
        curse: "4",
        ascension: "7",
        dazzle: "7",
        morimaru: "7"
    },
    {
        No: "081(51)",
        名前: "シドー",
        attack: "0",
        sleep: "6",
        curse: "7",
        ascension: "7",
        dazzle: "5",
        morimaru: "0"
    }
]